export var HOURS = 'hours';

export var MINUTES = 'minutes';


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-pickers/src/constants/clock-types.js
// module id = 1274
// module chunks = 0